<template>
  <div class="login">
    <div class="logo">
      <img src="@/assets/slogan.png" alt="" />
      <!-- <div class="slogon">
        <p>运输，</p>
        <p>还是顺丰运力靠谱</p>
      </div> -->
      <video muted autoplay loop src="@/assets/login.mp4">
        your browser does not support the video tag
      </video>
    </div>
    <div class="login-form">
      <el-tabs v-model="activeName" @tab-click="toggleTabs">
        <el-tab-pane label="密码登录" name="first">
          <el-input
            placeholder="请输入手机号码"
            v-model.trim="phone"
            maxlength="11"
            class="input-with-select"
            @focus="showAccounts"
          >
            <!-- <el-select
              v-model="select"
              slot="prepend"
              placeholder="请选择"
              popper-class="selectPhonePrefix"
            >
              <el-option label="大陆+86" value="1"></el-option>
            </el-select> -->
          </el-input>
          <el-input
            placeholder="请输入密码"
            v-model="password"
            show-password
          ></el-input>
          <slider-code
            class="slideone"
            v-model="verifyPass"
            @on-success="listenFromVerify"
          ></slider-code>
          <div
            class="noshow accounts"
            v-show="accounts.length > 0 && isshowAccounts"
          >
            <ul>
              <li
                v-for="(item, index) in accounts"
                :key="index"
                @click="fillPhone(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="验证码登录" name="second">
          <el-input
            placeholder="请输入手机号码"
            v-model.trim="phone"
            maxlength="11"
            @focus="showAccounts"
            class="input-with-select"
          >
            <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="大陆+86" value="1"></el-option>
            </el-select> -->
          </el-input>
          <slider-code
            v-model="verifyPass"
            @on-success="listenFromVerify2"
          ></slider-code>
          <el-input v-model="vCode" placeholder="请输入验证码">
            <el-button
              class="vcode"
              slot="append"
              @click="getvCode('handleclick')"
              style="width: 140px"
              >{{ vcodeText }}</el-button
            >
          </el-input>
          <div
            class="noshow accounts"
            v-show="accounts.length > 0 && isshowAccounts"
          >
            <ul>
              <li
                v-for="(item, index) in accounts"
                :key="index"
                @click="fillPhone(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="account-pwd">
        <el-checkbox v-model="readFlag"
          >我已阅读并同意
          <span class="color_blue" @click.prevent="desClick(0)"
            >《用户服务协议》</span
          >与<span class="color_blue" @click.prevent="desClick(1)"
            >《隐私政策》</span
          >
        </el-checkbox>
      </div>
      <el-button type="danger" @click="onLogin">登录</el-button>
      <div class="account-pwd">
        <!-- <el-checkbox v-model="rememberAccount">记住账号</el-checkbox> -->
        <span @click="goRegister" v-if="registerFlag">立即注册</span>
        <span class="right" @click="goSecret">忘记密码？</span>
      </div>
    </div>
    <el-dialog
      title="安全验证"
      :visible.sync="dialogVisible"
      width="468px"
      :before-close="handleClose"
    >
      <div class="wrapper">
        <div class="tip">
          为了保障您的账户安全，确保是您本人操作，请进行安全验证
        </div>
        <div class="w">
          <el-input
            placeholder="请输入手机号码"
            v-model.trim="form.phone"
            disabled
            maxlength="11"
            @focus="showAccounts"
          >
          </el-input>
          <!-- <first-slider-code
              style="margin-top:10px;"
              v-model="verifyPass2"
              @on-success="listenFromVerify3"
            ></first-slider-code> -->
          <el-input
            class="vcodeStyle"
            v-model="form.vCode"
            placeholder="请输入验证码"
          >
            <el-button
              class="vcode"
              slot="append"
              @click="getAuthCode"
              style="width: 140px"
              >{{ authcodeText }}</el-button
            >
          </el-input>
          <el-button type="danger" style="width: 100%" @click="submit()"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 用户服务协议 -->
    <el-dialog
      :fullscreen="true"
      title="顺丰运力用户服务协议"
      :visible.sync="tipsDialogVisible"
      width="30%"
    >
      <pre>{{ text }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      :fullscreen="true"
      title="隐私政策"
      :visible.sync="tipsYSDialogVisible"
      width="30%"
    >
      <privacyPolicy @lookHistory="desClick(2)" @lookChildrenRule="desClick(3)"></privacyPolicy>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsYSDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策历史版本 -->
    <el-dialog
      :fullscreen="true"
      title="隐私政策历史版本"
      :visible.sync="tipsLSBBDialogVisible"
      width="30%"
    >
      <privacyHistory @goCurrentVersion="desClick(1)"></privacyHistory>
    </el-dialog>
    <!-- 儿童个人信息保护规则 -->
    <el-dialog
      :fullscreen="true"
      title="儿童个人信息保护规则"
      :visible.sync="tipsChildrenDialogVisible"
      width="30%"
    >
      <childrenSafeRule></childrenSafeRule>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsChildrenDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { text1 } from "./text";
import sliderCode from "@/components/sliderCode";
import firstSliderCode from "./sliderCode";
import privacyPolicy from "./file/privacyPolicy/index.vue"
import privacyHistory from "./file/privacyHistory/index.vue"
import childrenSafeRule from "./file/childrenSafeRule/index.vue"
import { mapActions } from "vuex";
import aes from "@/utils/way";
import { _CONFIG_ } from "@/common/js/config.js"
export default {
  components: {
    sliderCode,
    firstSliderCode,
    privacyPolicy,
    privacyHistory,
    childrenSafeRule
  },
  data() {
    return {
      rules: {
        telephone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入正确的联系方式",
            trigger: "blur",
          },
        ],
        vCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{3,6}$/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
      },
      form: {
        phone: "",
        vCode: "",
      },
      dialogVisible: false,
      accounts: [],
      isshowAccounts: false,
      rememberAccount: false,
      activeName: "first",
      select: "1",
      phone: "",
      password: "",
      vCode: "",
      textConst: "获取验证码",
      vcodeText: "获取验证码",
      authcodeText: "获取验证码",
      verifyPass: false,
      verifyPass2: false,
      codekey: "",
      coordinate: "",
      flag: false,
      registerFlag:window['registerFlag'],
      readFlag: false,
      tipsDialogVisible: false,
      text: text1,
      tipsYSDialogVisible: false,
      tipsLSBBDialogVisible: false,
      tipsChildrenDialogVisible: false
    };
  },
  methods: {
    ...mapActions(["login", "sendVerifyCodeApi"]),
    handleClose() {
      this.dialogVisible = false;
    },
    desClick(val) {
      switch(val) {
        case 0: //用户服务协议
          this.tipsDialogVisible = true;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = false;
          break;
        case 1: //隐私政策
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = true;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = false;
          break;
        case 2: //隐私政策历史版本
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = true;
          this.tipsChildrenDialogVisible = false;
          break;
        case 3: //儿童个人信息保护规则
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = true;
          break;
        default:
          return false;
          break;
      }
    },
    submit() {
      this.onLogin("secureVcode"); // 输入验证码成功后再登录
      this.dialogVisible = false;
    },
    goSecret() {
      this.$router.push("/secret");
    },
    goRegister() {
      this.saveAccount();
      this.$router.push("/register");
    },
    showAccounts() {
      this.isshowAccounts = true;
    },
    hideAccounts() {
      setTimeout(() => {
        this.isshowAccounts = false;
      }, 100);
    },
    fillPhone(item) {
      console.log(item);
      this.phone = item;
      this.hideAccounts();
    },
    saveAccount() {
      let curr = localStorage.getItem("accounts");
      if (curr) {
        if (curr.indexOf(this.phone) == -1) {
          localStorage.setItem("accounts", curr + "," + this.phone);
        }
      } else {
        localStorage.setItem("accounts", this.phone);
      }
    },
    onLogin(type) {
      if (!this.readFlag) {
        this.$message.error("请先勾选我已阅读");
        return;
      }
      let params = {
        username: this.phone,
        password: aes.encrypt(this.password),
        loginType: this.activeName == "first" ? 1 : 2,
        verifykey: this.coordinate,
        verifyid: this.codekey,
        vCode: this.vCode,
      };
      if (type == "secureVcode") {
        params.username = localStorage.getItem("changeAccounts");
        params.vCode = this.form.vCode;
        params.loginType = 2;
        params.verifyType = "1";
      }
      localStorage.setItem("changeAccounts", params.username);
      this.login(params)
        .then(async (res) => {
          if (res.code == "4") {
            const CONFIG = window._CONFIG_ || _CONFIG_
            const lastdate = new Date(CONFIG.lastdate).getTime()
            const nowDate = new Date().getTime()
            const uri = CONFIG.login_uri + encodeURIComponent(CONFIG.redirect_home)
            console.log(`登录地址：${decodeURIComponent(uri)}`)
            // 截止日期之前，让用户自行选择是否跳转B端系统
            if (nowDate <= lastdate) {
              try {
                await this.$confirm('我司升级了账号加密系统，点击确定可自动跳转到新门户登陆！', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                // 重定向B端登出地址
                window.location.href = uri
                return
              } catch (e) {
                // TODO 若取消继续走老的登录逻辑
              }
            }
          }
          this.saveAccount();
          if (res.code == "3") {
            let tel = this.phone;
            tel = "" + tel;
            let reg = /(\d{3})\d{4}(\d{4})/;
            let tel1 = tel.replace(reg, "$1****$2");
            console.log(tel1);
            this.form.phone = tel1;
            this.dialogVisible = true;
          } else {
            this.$sensors.login(this.phone);
						this.$sensors.setProfile({user_name:this.phone});
            this.$router.push({
              path: "/manage/HomePage",
              query: { code: res.code },
            });
          }
          // 点击登录按钮如果是每天的密码第一次登录则出弹窗输入验证码否则直接登录
        })
        .catch((e) => {
          this.verifyPass = false;
        });
    },
    getAuthCode() {
      let mobile = localStorage.getItem("changeAccounts");
      let params = {
        mobile,
        reqid: this.codekey,
        resultSet: this.coordinate
      };
      this.sendVerifyCodeApi(params)
        .then((d) => {
          this.countChange();
        })
        .catch((e) => {});
    },
    getvCode(data) {
      let params = {};
      if (data === 'handleclick') {
        params.mobile = this.phone;
        params.reqid = this.codekey;
        params.resultSet = this.coordinate;
      } else {
        params.mobile = this.phone;
        params.reqid = data.reqid;
        params.resultSet = data.resultSet;
      }
      if (!this.verifyPass) {
        this.$message({
          type: "warning",
          message: "请移动滑块，完成拼图验证",
        });
        return;
      }
      if (this.vcodeText != this.textConst) {
        return;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) {
        this.$message({
          type: "warning",
          message: "请输入正确的手机号",
        });
        return;
      }
      this.sendVerifyCodeApi(params)
        .then((d) => {
          this.countdown();
        })
        .catch((e) => {});
    },
    countChange() {
      let seconds = 60;
      let tm = setInterval(() => {
        if (seconds == 0) {
          this.authcodeText = this.textConst;
          clearInterval(tm);
          return;
        }
        this.authcodeText = seconds + "S";
        seconds--;
      }, 1000);
    },
    countdown() {
      let seconds = 60;
      let tm = setInterval(() => {
        if (seconds == 0) {
          this.vcodeText = this.textConst;
          clearInterval(tm);
          return;
        }
        this.vcodeText = seconds + "S";
        seconds--;
      }, 1000);
    },
    toggleTabs() {
      /* console.log(this.activeName,tab, event); */
    },
    listenFromVerify(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
    },
    listenFromVerify2(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
      this.getvCode(data);
    },
    listenFromVerify3(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
      this.getvCode(data);
    },
  },
  created() {
    const CONFIG = window._CONFIG_ || _CONFIG_
    const lastdate = new Date(CONFIG.lastdate).getTime()
    const nowDate = new Date().getTime()
    const uri = CONFIG.login_uri + encodeURIComponent(CONFIG.redirect_home)
    // 截止日期之后，直接跳转到B端系统
    if (nowDate > lastdate) {
      window.location.href = uri
      return
    }
    let phone = localStorage.getItem("accounts");
    if (phone) {
      this.accounts = phone.split(",");
      this.phone = this.accounts[this.accounts.length - 1];
    }
  },
  mounted() {
    let that = this;
    document.body.addEventListener("click", (event) => {
      if ("el-input__inner" !== event.target.className) {
        that.hideAccounts();
      }
    });
  },
  /* watch: {
    rememberAccount() {
      this.saveAccount();
    },
  }, */
};
</script>
<style lang="less" scoped>
.accounts {
  position: absolute;
  top: 50px;
  left: 0px;
  width: 388px;
  box-shadow: 0 0px 5px #95b2e2;
  min-height: 80px;
  background-color: #2b3d5b;
  color: #fff;
  font-size: 14px;
  z-index: 10000;
  ul {
    list-style: none;
    padding-left: 0;
    line-height: 2.4;
    margin: 0 !important;
    li {
      padding-left: 10px !important;
      cursor: pointer;
      &:hover {
        background-color: rgb(31, 46, 74);
      }
    }
  }
}
.login-form {
  /deep/ .el-input.is-active .el-input__inner,
  /deep/ .el-input__inner:focus {
    border-color: transparent !important;
  }
}
.login .login-form .account-pwd /deep/ span {
  color: #fff;
  &.el-checkbox__input {
    margin-right: 5px !important;
  }
}
.wrapper {
  padding: 20px !important;
  .tip {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.55);
    line-height: 24px;
    margin: 20px 0 !important;
    text-align: center;
  }
  .w {
    height: 240px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}

.wrapper /deep/ .el-input-group__append {
  background-color: transparent;
}
.vcodeStyle /deep/ .el-input__inner {
  border-right: none;
}
.wrapper /deep/ .el-button {
  height: 45px;
}

.color_blue {
  color: #84a9f2 !important;
}
</style>